import {l} from "types/typescriptdefinisjoner_lederplan";
import {StrengMaler} from "../tjenester/StrengMaler";

export function strengMalFilterForInjisering() {
    return [StrengMaler.regNavn, strengMalFilter];
}

/**
 * filter for interpolering av l.StrengMal instanser.
 * Se {@link StrengMaler}
 *
 * Bruker:
 * Siden filteret returnerer html må ng-bind-html benyttes for at ikke htmlen skal escapes, eks:
 * <span ng-bind-html="kommentar.forelder.beskrivelse | strengMal"></span> eller
 * <span ng-bind-html="kommentar.forelder.beskrivelse | strengMal:'lang'"></span>
 *
 * format-argumentet kan være en av "lang", "kort" og angir hvorvidt
 * ft.StrenMal.somFullStreng eller ft.StrenMal.somKortStreng benyttes.
 *
 * Dersom format ikke er angitt benyttes "kort".
 *
 * @returns {function(l.StrengMal, format): string}
 */
export function strengMalFilter(strengMal: StrengMaler): Function {
    return (mal: l.StrengMal<any>, format: string): string => {
        if (!mal) return "";
        return format == "lang" ?
            strengMal.somFullStreng(mal) : strengMal.somKortStreng(mal);
    }
}
